export const arrayToClassName = (arr: Array<string>) => arr.join(' ')

export const pxToPCVW = (n: number):`${number}vw` => `${(n / 1920) * 100}vw`;
